import React from 'react'
import CheckboxInput from '../inputs/CheckboxInput'

export default function PaymentMethod({children, value, label, description}) {
    return (
        <div className={'payment-method'}>
            <CheckboxInput
                label={label}
                value={value}
                name={'method'} subobj={'payment'}
            />
            {description && (<div className={'payment-method__description'}>{description}</div>)}
            {children}
        </div>
    )
}